// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1WCOy","alert":"SettungsInbox_alert__1qO5x"};